/*
  Page configuration for the One Portal — Sales Submission drill-down.

  One Portal is the dealer-facing front door, and its sales figures come from the
  One Portal team's own API rather than OWEHub — which the payloads show as null
  `data_as_of` / `table_last_modified`, a `"UTC"` source timezone, a
  `cancelled_today` that is always 0, and no `contract_value_total`. The screen
  handles all of that generically ("n/a" for a null), so nothing here has to.

  The filter row differs too: One Portal rejects `office` with a 400 and treats
  `state` and `region` as one dimension — handled in `toFilterGroups`, which
  branches on the catalogue's `platform`.
*/

import type { SystemPageConfig } from './system-intelligence'

export const onePortalPage: SystemPageConfig = {
  service: 'one-portal',
  title: 'One Portal — Sales Submission',
  unit: 'Submissions',
  // Same layout as Aurora and Solo: the scope row first, then three tiles —
  // response time, 30-day uptime, submissions today — and no period summary
  // row. Dropping that row also retires the one tile this platform could never
  // fill: it has no contract value at all.
  salesTodayHeader: true,
}
